import Vue from 'vue';
import WarningSection from '~/modules/debt-sold/components/warning-section.vue';
import WarningModal from '~/modules/debt-sold/components/warning-modal.vue';

Vue.component('ds-warning-section', WarningSection);
Vue.component('ds-warning-modal', WarningModal);
